/**
 * Empleados de la entrada (GEN-PX-012). Se piden UNA vez al montar y no bloquean nada: mientras
 * llegan, o si el kernel no deja verlos (403) o falla, `empleados` es null y la sección no se pinta.
 */

import { useEffect, useState } from 'react'
import { listEmpleados } from '../../api/client.js'
import { logError } from '../../lib/log.js'

/** -> lista de { nombre, cargo, rol, estado } o null (cargando / sin permiso / error). */
export default function useEmpleados() {
  const [empleados, setEmpleados] = useState(null)
  useEffect(() => {
    let vivo = true
    Promise.resolve().then(() => listEmpleados())
      .then(r => { if (vivo) setEmpleados(Array.isArray(r?.empleados) ? r.empleados : null) })
      .catch(err => { logError('entrada.empleados.error', { code: err?.code, status: err?.status }); if (vivo) setEmpleados(null) })
    return () => { vivo = false }
  }, [])
  return empleados
}
